<div class="content-loading" *ngIf="isLoading">
  <div class="loading">
      <p class="text-center"><i class="fa fa-spinner fa-spin fa-2x text-white"></i></p>
      <p class="text-center lead">Espere un momento, por favor...</p>
      <p class="text-center">
          <button (click)="backToHome()" class="btn btn-sm btn-danger">CANCELAR</button>
      </p>
  </div>
</div>
